import { useQuery } from '@tanstack/react-query';
import { UserProfile } from 'src/types';
import { baseFetch } from 'src/utils';

export const useCurrentUser = () => {
  const query = useQuery({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const res = await baseFetch("/user/currentUser", {
        method: 'GET',
      });
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await res.json();

      if (!data.user) {
        return null;
      }

      if (!data.user.carts) {
        data.user.carts = [];
      }

      return data.user as UserProfile;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    ...query,
    // Normalize `undefined` (query not yet resolved) to `null` so consumers
    // always get `UserProfile | null` — matching the old Jotai atom type.
    user: query.data ?? null,
  };
};
